/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartSubscriptionFlowRequest
 */
export interface StartSubscriptionFlowRequest {
    /**
     * 
     * @type {string}
     * @memberof StartSubscriptionFlowRequest
     */
    email: string;
}

/**
 * Check if a given object implements the StartSubscriptionFlowRequest interface.
 */
export function instanceOfStartSubscriptionFlowRequest(value: object): value is StartSubscriptionFlowRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function StartSubscriptionFlowRequestFromJSON(json: any): StartSubscriptionFlowRequest {
    return StartSubscriptionFlowRequestFromJSONTyped(json, false);
}

export function StartSubscriptionFlowRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartSubscriptionFlowRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function StartSubscriptionFlowRequestToJSON(json: any): StartSubscriptionFlowRequest {
    return StartSubscriptionFlowRequestToJSONTyped(json, false);
}

export function StartSubscriptionFlowRequestToJSONTyped(value?: StartSubscriptionFlowRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

